import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import usePageMeta from '../hooks/usePageMeta';
import { SITE_NAME, SITE_TAGLINE, SITE_DESCRIPTION } from '../config/site';

/**
 * Public landing page. Deliberately minimal — the game is the product, so
 * this exists to explain what it is and route people into it.
 */
function Landing() {
  const { token } = useContext(AuthContext);

  usePageMeta({
    title: null,
    description: SITE_DESCRIPTION,
    canonicalPath: '/',
  });

  return (
    <div className="min-h-[calc(100vh-5rem)] bg-navy flex items-center">
      <div className="mx-auto max-w-3xl px-6 py-20 text-center">
        <h1 className="text-4xl sm:text-6xl font-bold text-white tracking-tight">
          {SITE_NAME}
        </h1>
        <p className="mt-4 text-xl text-primary">
          {SITE_TAGLINE}
        </p>
        <p className="mt-6 text-base text-gray-400 max-w-xl mx-auto">
          {SITE_DESCRIPTION}
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          {token ? (
            <Link
              to="/play"
              className="w-full sm:w-auto px-8 py-3 text-base font-semibold text-navy bg-primary hover:bg-primary-dark rounded-md transition-colors"
            >
              Play now
            </Link>
          ) : (
            <>
              <Link
                to="/register"
                className="w-full sm:w-auto px-8 py-3 text-base font-semibold text-navy bg-primary hover:bg-primary-dark rounded-md transition-colors"
              >
                Create an account
              </Link>
              <Link
                to="/login"
                className="w-full sm:w-auto px-8 py-3 text-base font-semibold text-gray-300 hover:text-white transition-colors"
              >
                Log in
              </Link>
            </>
          )}
        </div>

        <p className="mt-12 text-sm text-gray-500">
          <Link to="/leaderboard" className="hover:text-primary transition-colors">
            View the leaderboard
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Landing;
